import PropTypes from 'prop-types'
import { Component } from 'react'

import { LocationContainer } from './styles'

export class MapMiniWidget extends Component {
  static propTypes = {
    address: PropTypes.string,
    phone: PropTypes.string,
    photo: PropTypes.string,
    className: PropTypes.string,
  }

  static defaultProps = {
    address: '',
    phone: '',
    photo: '',
    className: '',
  }

  render() {
    const {
      className, phone, address, photo
    } = this.props
    return (
      <LocationContainer className={className}>
        <img className="locationLogo" src={photo || '/static/images/empty-place.svg'} alt={address} />
        <p>
          {address}<br/>{phone}
        </p>
      </LocationContainer>
    )
  }
}
